// Red de seguridad: sin esto, cualquier excepción durante el render de
// CUALQUIER pantalla (un campo inesperado del backend, un .map sobre algo
// que no es array, etc.) desmonta todo el árbol de React y deja la pantalla
// completamente en blanco, sin ningún mensaje — React 18 no vuelve a
// renderizar nada después de un error no capturado. Esto lo intercepta y
// muestra algo recuperable en su lugar.
import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { ErrorOutline, Refresh } from '@mui/icons-material';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary capturó un error de render:', error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <Box sx={{
          minHeight: '100vh', display: 'flex', flexDirection: 'column',
          alignItems: 'center', justifyContent: 'center', gap: 2, p: 3, bgcolor: '#F4F4F4',
        }}>
          <ErrorOutline sx={{ fontSize: 56, color: '#ef4444' }} />
          <Typography variant="h6" fontWeight={700} sx={{ color: '#282626' }}>
            Algo salió mal en esta pantalla
          </Typography>
          <Typography variant="body2" sx={{ color: '#888', textAlign: 'center', maxWidth: 420 }}>
            No se perdió ningún dato guardado — solo esta vista tuvo un error inesperado.
            Recarga la página para continuar.
          </Typography>
          <Button variant="contained" startIcon={<Refresh />} onClick={() => window.location.reload()}
            sx={{ borderRadius: 2, textTransform: 'none', fontWeight: 700, bgcolor: '#282626', '&:hover': { bgcolor: '#1a1a1a' } }}>
            Recargar
          </Button>
        </Box>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
